import React from 'react'
import {Switch,Route} from 'react-router-dom'
import asyncComponent from "../../../util/asyncComponent";
const ReportCXP =({match})=>(
    <Switch>
          <Route  path={`${match.url}/CXPSummary`} component={asyncComponent(()=>import( './CXPSummary/index'))} />
    </Switch>
)
export default ReportCXP;